export type Ok<T> = { readonly ok: true; readonly value: T };
export type Err<E> = { readonly ok: false; readonly error: E };
export type Result<T, E> = Ok<T> | Err<E>;

export const ok = <T>(value: T): Ok<T> => ({ ok: true, value });
export const err = <E>(error: E): Err<E> => ({ ok: false, error });

export class DomainError extends Error {
  readonly code: string;
  constructor(code: string, message: string) {
    super(`${code}: ${message}`);
    this.code = code;
    this.name = 'DomainError';
  }
}

export function unwrap<T, E>(r: Result<T, E>): T {
  if (r.ok) return r.value;
  const e = r.error as unknown;
  throw e instanceof Error ? e : new DomainError('UNWRAP', JSON.stringify(e));
}
